import React from "react";
import ProductMenu from "../../components/UI/Productmenu";

import { filterList } from "../../Lists/products/filterList";

import classes from "./Products.module.css";
import { Helmet } from "react-helmet";

const Filter = () => {
  const pageTitle = "Sistemas de filtración";

  return (
    <div className={classes.showStoreList}>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name={pageTitle} content="Sistemas de filtración" />
      </Helmet>
      <div className={classes.familyMainInfo}>
        <h1>{pageTitle}</h1>
        <p>
          Contamos con una amplia variedad de filtros: desde kits completos para
          uso residencial y carcasas individuales en diferentes tamaños, hasta
          sistemas de filtrado de gran capacidad para comercios. También
          ofrecemos lámparas purificadoras, suavizadores de agua y repuestos
          como filtros de carbón activado y de sedimento en polipropileno.
        </p>
      </div>
      <ProductMenu list={filterList}></ProductMenu>
    </div>
  );
};

export default Filter;
